/* eslint-disable react-hooks/exhaustive-deps */
import { parseError, URLS } from "@core/shared/utils";
import { useAction } from "@framework/shared/hooks";
import { useEffect } from "react";
import { lessonOffersAtom } from "../atoms/lesson-offers.atom";

export function useLessonOffers(lessonId?: number) {
  const action = useAction(URLS.offers.api);
  const { offers, isLoading, error, hasLoaded } = lessonOffersAtom.useValue();

  const fetchOffers = async () => {
    const { hasLoaded, isLoading } = lessonOffersAtom.value;

    if (!lessonId || hasLoaded || isLoading) return;

    lessonOffersAtom.merge({
      isLoading: true,
      error: null,
      hasLoaded: false,
    });

    try {
      const response = await action({
        lesson: lessonId,
      });

      if (response.isOK && response.data) {
        lessonOffersAtom.merge({
          offers: response.data.offers || [],
          hasLoaded: true,
          isLoading: false,
        });
      }
    } catch (err) {
      lessonOffersAtom.merge({
        error: parseError(err),
        hasLoaded: true,
        isLoading: false,
      });
    }
  };

  useEffect(() => {
    lessonOffersAtom.silentReset();

    fetchOffers();

    return () => {
      lessonOffersAtom.silentReset();
    };
  }, [lessonId]);

  return {
    offers,
    isLoading,
    error,
    fetchOffers,
    hasLoaded,
    count: offers.length,
  };
}
